import { api, API } from "./auth";

export { api, API };

export async function listSystems() {
    const { data } = await api.get("/systems");
    return data;
}
export async function getSystem(id) {
    const { data } = await api.get(`/systems/${id}`);
    return data;
}
export async function createSystem(payload) {
    const { data } = await api.post("/systems", payload);
    return data;
}
export async function deleteSystem(id) {
    const { data } = await api.delete(`/systems/${id}`);
    return data;
}
export async function seedSystems() {
    const { data } = await api.post("/seed");
    return data;
}
export async function getStats() {
    const { data } = await api.get("/stats");
    return data;
}
export async function listDocuments(id) {
    const { data } = await api.get(`/systems/${id}/documents`);
    return data;
}
export function documentFileURL(docId, download = false) {
    return `${api.defaults.baseURL}/documents/${docId}/file${
        download ? "?download=1" : ""
    }`;
}
export async function seedDocuments(id) {
    const { data } = await api.post(`/systems/${id}/documents/seed`);
    return data;
}
export async function uploadDocument(id, file, docType) {
    const fd = new FormData();
    fd.append("file", file);
    if (docType) fd.append("doc_type", docType);
    const { data } = await api.post(`/systems/${id}/documents`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}
export async function runAudit(id) {
    const { data } = await api.post(`/systems/${id}/audit/run`);
    return data;
}
export async function getAuditJob(jobId) {
    const { data } = await api.get(`/audit/jobs/${jobId}`);
    return data;
}
export async function saveSnapshot(systemId, label) {
    const { data } = await api.post(`/systems/${systemId}/snapshot`, { label });
    return data;
}
export async function listSnapshots() {
    const { data } = await api.get("/snapshots");
    return data;
}
export async function restoreSnapshot(snapshotId, systemId) {
    const { data } = await api.post(
        `/snapshots/${snapshotId}/restore/${systemId}`,
    );
    return data;
}
export async function deleteSnapshot(id) {
    const { data } = await api.delete(`/snapshots/${id}`);
    return data;
}
export async function signAudit(auditId, payload) {
    const { data } = await api.post(`/audits/${auditId}/sign`, payload);
    return data;
}
export async function getRules(id) {
    const { data } = await api.get(`/systems/${id}/rules`);
    return data;
}
export async function getRequirements(id) {
    const { data } = await api.get(`/systems/${id}/requirements`);
    return data;
}
export async function getFindings(id) {
    const { data } = await api.get(`/systems/${id}/findings`);
    return data;
}
export async function getTraceability(id) {
    const { data } = await api.get(`/systems/${id}/traceability`);
    return data;
}
export async function getLatestAudit(id) {
    const { data } = await api.get(`/systems/${id}/audit/latest`);
    return data;
}
export async function getSopLibrary(docType) {
    const { data } = await api.get("/sops", {
        params: docType ? { doc_type: docType } : {},
    });
    return data;
}
export async function bulkReauditSOP(filename) {
    const { data } = await api.post("/sops/reaudit", { filename });
    return data;
}
export async function getSopDiff(filename, { docA, docB } = {}) {
    const params = {};
    if (docA) params.doc_a = docA;
    if (docB) params.doc_b = docB;
    const { data } = await api.get(
        `/sops/${encodeURIComponent(filename)}/diff`,
        { params },
    );
    return data;
}
export async function getFindingsLibrary({ severity, status } = {}) {
    const params = {};
    if (severity && severity !== "All") params.severity = severity;
    if (status && status !== "All") params.status = status;
    const { data } = await api.get("/findings", { params });
    return data;
}
export async function updateFinding(findingId, payload) {
    const { data } = await api.patch(`/findings/${findingId}`, payload);
    return data;
}
export async function approveFinding(findingId, payload) {
    const { data } = await api.post(`/findings/${findingId}/approve`, payload);
    return data;
}

// --- auth-adjacent ---
export async function listOrgUsers() {
    const { data } = await api.get("/auth/users");
    return data;
}
export async function startDemoSession() {
    const { data } = await api.post("/auth/demo-session", {});
    return data;
}
export async function inviteUser(payload) {
    const { data } = await api.post("/auth/users/invite", payload);
    return data;
}
export async function updateOrgUser(userId, payload) {
    const { data } = await api.patch(`/auth/users/${userId}`, payload);
    return data;
}
export async function getActivity(params = {}) {
    const { data } = await api.get("/auth/activity", { params });
    return data;
}
